import { render, staticRenderFns } from "./uploadTable.vue?vue&type=template&id=2cd8c68e&scoped=true"
import script from "./uploadTable.vue?vue&type=script&lang=js"
export * from "./uploadTable.vue?vue&type=script&lang=js"
import style0 from "./uploadTable.vue?vue&type=style&index=0&id=2cd8c68e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8c68e",
  null
  
)

export default component.exports